import { render, staticRenderFns } from "./UnifiedQuery.vue?vue&type=template&id=5ffe7c72&scoped=true"
import script from "./UnifiedQuery.vue?vue&type=script&lang=js"
export * from "./UnifiedQuery.vue?vue&type=script&lang=js"
import style0 from "./UnifiedQuery.vue?vue&type=style&index=0&id=5ffe7c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe7c72",
  null
  
)

export default component.exports